import React, { useMemo } from "react";
import {
  ByodContainer,
  ByodImg,
} from "./styles";

const ByodPackageImage = ({ device, description, width = 100, height = 100 ,deviceList}) => {
  const brand = device?.brand || description?.brand;
  const name = device?.productName || description?.name;
  const imageSet = useMemo(() => {
    const imageCDN = "//ss7.vzw.com/is/image/VerizonWireless/";
    const carouselImageset = [];
    if (device !== null && device && Object.keys(device).length && device?.image) {
      carouselImageset.push(
        `${imageCDN}${device.image}?$acc-lg$&hei=${height}&wid=${width}`
      );
    } else if (device !== null && device && Object.keys(device).length && device?.imageSet) {
      carouselImageset.push(
        `${imageCDN}${device.imageSet}?$acc-lg$&hei=${height}&wid=${width}`
      );
    } else if (description !==null && description && Object.keys(description).length) {
      if (description?.image) {
        carouselImageset.push(
          `${imageCDN}${description?.image}?$acc-lg$&hei=${height}&wid=${width}`
        );
      }
    }else if(deviceList!==null&&deviceList&&deviceList?.selectedDevice!==null&&deviceList?.selectedDevice&&deviceList?.selectedDevice?.imageName && !device?.imei?.length){
      carouselImageset.push(
        `${imageCDN}${deviceList?.selectedDevice?.imageName}?$acc-lg$&hei=${height}&wid=${width}`
      );
    }
    return carouselImageset;
  }, [device?.image, device?.description, device?.imageSet]);

  if (imageSet?.length) {
    return (
      <img
        src={imageSet[0]}
        alt={`${brand} - ${name}`}
        width={width}
        height={height}
      />
    );
  } else {
      return (
        <ByodContainer width={width} height={height}>
          <ByodImg />
        </ByodContainer>
      );
  }
};

export default ByodPackageImage;
